import axios from 'axios';
import API_CONFIG from '../config/api';
import { clearSession } from './session';
import { translateStatic } from '../i18n/LocaleContext';

const API_URL = API_CONFIG.getApiUrl(API_CONFIG.ENDPOINTS.AUTH);

const MOCK_ACCOUNT = {
  identifier: 'demo',
  password: '123456',
  user: {
    id: 1,
    full_name: 'Demo User',
    email: 'demo@jobapp.com',
    phone: '0123456789',
    role: 'user'
  }
};

const ADMIN_ACCOUNT = {
  identifier: 'admin@jobapp.com',
  password: 'admin123',
  user: {
    id: 999,
    full_name: 'Administrator',
    email: 'admin@jobapp.com',
    phone: '0999999999',
    role: 'admin'
  }
};

export const authService = {
  register: async (userData) => {
    try {
      const response = await axios.post(`${API_URL}/register`, userData);
      if (response.data.token) {
        localStorage.setItem('token', response.data.token);
        localStorage.setItem('user', JSON.stringify(response.data.user));
      }
      return response.data;
    } catch (error) {
      const errorMessage = error.response?.data?.error || translateStatic('registrationFailed');
      throw new Error(errorMessage);
    }
  },

  login: async (credentials) => {
    try {
      const response = await axios.post(`${API_URL}/login`, credentials);
      if (response.data.token) {
        localStorage.setItem('token', response.data.token);
        localStorage.setItem('user', JSON.stringify(response.data.user));
      }
      return response.data;
    } catch (error) {
      const errorMessage = error.response?.data?.error || translateStatic('loginFailed');
      throw new Error(errorMessage);
    }
  },

  logout: () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
  },

  // 后台域名登录：先验角色再落盘，会员账号不会拿到一个进不去后台的“半登录态”
  adminLogin: async (credentials) => {
    let response;
    try {
      response = await axios.post(`${API_URL}/login`, credentials);
    } catch (error) {
      throw new Error(error.response?.data?.error || translateStatic('loginFailed'));
    }
    const user = response.data?.user;
    const role = user?.userType || user?.role;
    if (role !== 'admin' && role !== 'referral_admin') {
      throw new Error('NO_ADMIN_PERMISSION');
    }
    if (response.data.token) {
      localStorage.setItem('token', response.data.token);
      localStorage.setItem('user', JSON.stringify(response.data.user));
    }
    return response.data;
  },

  // 坏掉的 localStorage.user 以前会直接把整个应用炸成白屏，
  // 这里遇到解析失败就清掉会话，退回登录页。
  getCurrentUser: () => {
    const userStr = localStorage.getItem('user');
    if (!userStr) return null;
    try {
      const parsed = JSON.parse(userStr);
      return parsed && typeof parsed === 'object' ? parsed : null;
    } catch (e) {
      clearSession();
      return null;
    }
  },

  getToken: () => {
    return localStorage.getItem('token');
  },

  isAuthenticated: () => {
    return !!localStorage.getItem('token');
  }
};
